import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GA_MEASUREMENT_ID } from "@/lib/gaConfig";

export function GoogleAnalyticsPageview() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;

    const page_path = `${location.pathname}${location.search}${location.hash}`;

    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
      // Enhanced privacy settings
      anonymize_ip: true,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}


